import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SensorHistoryComponent } from './sensor-history.component';
import {SensorHistoryToolbarModule} from '../sensor-history-toolbar/sensor-history-toolbar.module';



@NgModule({
  declarations: [SensorHistoryComponent],
    imports: [
        CommonModule,
        SensorHistoryToolbarModule
    ],
  exports: [SensorHistoryComponent]
})
export class SensorHistoryModule { }
